
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/vibesuite",
      function () {
        return require("private-next-pages/tools/vibesuite/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/vibesuite"])
      });
    }
  